import React,{useState, useEffect} from 'react'
import PropTypes from 'prop-types';
import StepsCircle from '../components/stepCircles'
import SliderQuestionForm from  '../components/sliderQuestionForm-v2'
import { SpinnerImage } from '../components/spinner/spinner'
import RiskCarousel from '../components/riskCarousel-v2/riskcarousel'
import s from './riskTest.module.css'
import { propTypes } from 'react-recaptcha';
import { GTMEvents } from '../lib/GTMevents';
import { withPrefix } from 'gatsby';
import RiskImageOne from '../../static/images/prima-productos/risk-test-1.svg';
import RiskImageTwo from '../../static/images/prima-productos/risk-test-2.svg';

const questions = [ {
    title: '¿En qué rango de edad te encuentras?',
    options: [
      {
        id: 0,
        content: 'Menos de 40 años',
        value: 3
      },
      {
        id: 1,
        content: 'Entre 40 y 59 años',
        value: 2
      },
      {
        id: 2,
        content: 'Mayor o igual a 60 años',
        value: 1
      },
    ]
  },
  {
    title: '¿Cuántos años te faltan para acceder a tu jubilación?',
    options: [
      {
        id: 0,
        content: 'Menos de 5 años',
        value: 1
      },
      {
        id: 1,
        content: 'Entre 5 y 10 años',
        value: 2
      },
      {
        id: 2,
        content: 'Más de 10 años.',
        value: 3
      },
    ]
  },
  {
    title: '¿Cuántas personas dependerán económicamente de ti cuando te jubiles?',
    options: [
      {
        id: 0,
        content: 'Ninguna, sólo yo',
        value: 3
      },
      {
        id: 1,
        content: '1 o 2 personas',
        value: 2
      },
      {
        id: 2,
        content: '3 o más personas',
        value: 1
      },
    ]
  },
  {
    title: '¿En qué medida crees que necesitarás tu pensión de jubilación?',
    options: [
      {
        id: 0,
        content: 'Será mi principal fuente de ingreso',
        value: 1
      },
      {
        id: 1,
        content: 'Complementará mi fuente de ingresos',
        value: 2
      },
      {
        id: 2,
        content: 'No será mi principal fuente de ingresos',
        value: 3
      },
    ]
  },
  {
    title: '¿Con cuál de los perfiles de inversión te identificas?',
    options: [
      {
        id: 0,
        content: 'Conservador: No se siente cómodo con la fluctuación de la rentabilidad de las inversiones. Prefiere renunciar a la rentabilidad alta para mantener el capital',
        value: 1
      },
      {
        id: 1,
        content: 'Moderado: Está dispuesto a asumir fluctuaciones y pérdidas moderadas del capital y obtener crecimiento moderado en el tiempo',
        value: 2
      },
      {
        id: 2,
        content: 'Agresivo: Alto nivel de fluctuación en la búsqueda de mayores retornos',
        value: 3
      },
    ]
  },
  {
    title: 'Si usted está en un casino y ha perdido US$500 en el juego, ¿Cuánto estaría dispuesto a apostar para recuperarse?',
    options: [
      {
        id: 0,
        content: 'Ni un centavo más',
        value: 1
      },
      {
        id: 1,
        content: 'US$ 500',
        value: 2
      },
      {
        id: 2,
        content: 'Lo necesario',
        value: 3
      },
    ]
  },
  {
    title: 'Usted está en la final de un show de TV y tiene que tomar la última decisión. Sus alternativas son:',
    options: [
      {
        id: 0,
        content: 'Ganar US$ 1,000 en efectivo',
        value: 1
      },
      {
        id: 1,
        content: 'Arriesgarse y tener 30% de probabilidades de ganar US$ 10,000',
        value: 2
      },
      {
        id: 2,
        content: 'Arriesgarse y tener 10% de probabilidades de ganar US$ 100,000',
        value: 3
      },
    ]
  }
]

const RiskTest = (props) => {

  const {circleSteps, setCircleSteps, handleButtonClick, setClassName} = props;

  const [currentSlide, setCurrentSlide] = useState(0);
  const [riskStep, setRiskStep] = useState(1);
  const [testResult , setTestResult] = useState(0);

  const getSteps = (code) => {
    const stepIndex = circleSteps.findIndex((step) => step.code === code);
    const updateSteps = circleSteps.map((step, index) => {
      if (index === stepIndex) {
        return { ...step, current: true, active: false };
      }
  
      if (index < stepIndex) {
        return { ...step, current: false, active: true };
      }

      if (index > stepIndex) {
        return { ...step, current: false, active: false };
      }
      return step;
    });
    setCircleSteps(updateSteps)
  };

  const handleNextSlide = () => {
    (currentSlide + 1 < circleSteps.length) ? getSteps(circleSteps[currentSlide + 1].code) : setRiskStep(3);
  }

  const handlePrevSlide = () => {
    (currentSlide - 1 >= 0) ? getSteps(circleSteps[currentSlide - 1].code) : console.log('');
  }

  const handleRetakeTest = () => {
    setRiskStep(2)
    setTestResult(0)
    getSteps('QUESTION_1')
  }
  
  const handleOnClick = (sub_section, location) => {
    setRiskStep(2)
    GTMEvents.FundTypeScrollTestBtn(sub_section, location)
  }

  const renderRiskTestInit = () => {
    return (
      <>
        <img className={`${s.imgStep1}`} src={RiskImageOne} alt='' />
        <div id='GTM-MOD-MEP-SECTION-TP-BTN' className={`${s.initRiskTestContainer}`}>
          <div id='GTM-MOD-MEP-SECTION-TP-BTN-CONTAINER-ARROW' className='font-family-primary fw-4 tw-f-16 tw-f-18@lg pt-4 center tw-mb-4'>¿Conoces tu perfil de riesgo?</div>
          <h2 className={`${s.riskTestTitle} font-family-secondary fw-7 tw-f-20 tw-f-24lg center`}>Responde 7 preguntas para saber qué tipo de inversionista eres</h2>
          <div className={`${s.arrowIconContainer}`}>
            <input id='GTM-MOD-MEP-SECTION-TP-BTN-ARROW' type='image' alt='Clic aquí' onClick={ () => handleOnClick('Responde 7 preguntas para saber qué tipo de inversionista eres','/aportes-y-fondo/tipos-de-fondo') } className={`${s.riskTestArrowButton} m-auto flex`}  src={withPrefix('/images/prima-productos/risk-test-arrow.svg')} />
          </div>
        </div>
        <img className={`${s.imgStep1}`} src={RiskImageTwo} alt='' />
      </>
    )
  }

  const renderRiskQuestionsForm = () => {
    return (
      <div className={`${s.questionsForm}`}>
        <div className='pt-2 pb-3 pl-4 pr-4'>
          <StepsCircle steps={circleSteps}></StepsCircle>
        </div>
        <div className={`pb-4 ${s.customRiskTf}`}>
          <SliderQuestionForm data={questions} onPrevMethod={()=>handlePrevSlide()} onNextMethod={()=> handleNextSlide()} currentSlide={currentSlide} setCurrentSlide={setCurrentSlide} testResult={testResult} setTestResult={setTestResult}></SliderQuestionForm>
        </div>
      </div>
    )
  }
  const renderLoader = () => {
    return (
      <div className={`${s.containerSpinner} mt-4`}>
        <div className={`${s.spinner}`}>
          <SpinnerImage fill='#FF4F00' />
        </div>
        <p className='font-family-primary c-orange-0 tw-f-16 center pt-2 pb-3 pl-4 pr-4'>Te guiamos y acompañamos en tu progreso...</p>
      </div>
    )
  }

  useEffect(() => {
    if (riskStep === 3) {
      const timeout = setTimeout(() => {
        setRiskStep(4);
      }, 2000);
      return () => clearTimeout(timeout);
    }
  }, [riskStep]);

  return (
    <div className={`${riskStep !== 4 ? 'flex' : ''} ${setClassName || 'bg-yellow-1'} ${s.riskSection} justify-center ${riskStep === 1 && s.sectionHeigthStep1} ${riskStep !== 1 && s.sectionHeigth}`}>
      {riskStep === 1 && renderRiskTestInit()}
      {riskStep === 2 && renderRiskQuestionsForm()}
      {riskStep === 3 && renderLoader()}
      {riskStep === 4 && <RiskCarousel handleRetakeTest={handleRetakeTest} handleButtonClick={handleButtonClick} testResult={testResult}/>}
    </div>
  )
}

RiskTest.propTypes = {
  circleSteps: PropTypes.any.isRequired,
  setCircleSteps: PropTypes.any.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  setClassName: propTypes.string
};

export default RiskTest;
